import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type PdfDeliveryChoice = "print" | "download" | "cancel";
export type PdfDeliveryResolve = (choice: PdfDeliveryChoice) => void;

export interface PdfDeliveryDialogState {
  isOpen: boolean;
  fileName: string;
  title?: string;
  // resolve is kept outside Redux in pdfDeliveryDialogUtils.ts to avoid
  // serialisation warnings (same pattern as confirmationDialogSlice).
}

const initialState: PdfDeliveryDialogState = {
  isOpen: false,
  fileName: "",
  title: undefined,
};

const pdfDeliveryDialogSlice = createSlice({
  name: "pdfDeliveryDialog",
  initialState,
  reducers: {
    openPdfDeliveryDialog: (
      state,
      action: PayloadAction<{ fileName: string; title?: string }>
    ) => {
      state.isOpen = true;
      state.fileName = action.payload.fileName;
      state.title = action.payload.title;
    },
    closePdfDeliveryDialog: (state) => {
      state.isOpen = false;
      state.fileName = "";
      state.title = undefined;
    },
  },
});

export const { openPdfDeliveryDialog, closePdfDeliveryDialog } =
  pdfDeliveryDialogSlice.actions;

export default pdfDeliveryDialogSlice.reducer;
